export const getSupportersNumberByType = ({ selectedItems, type }) => {
    if (type === 'COLLECTIONS' || type === 'PRODUCTS') {
        return selectedItems.reduce((accAmount, currentItem) => {
            return accAmount + Number(currentItem.supportersTotal);
        }, 0);
    }
    return selectedItems.length;
};
